import React, { useState } from "react";
import "./style.css";
import Alert from "react-bootstrap/Alert";
import { auth, db } from "../firebase.config";
import { signInWithEmailAndPassword } from "firebase/auth";
import { getDoc, doc, collection } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";

export default function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState(false);
  const [verification, setVerification] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [netError, setNetError] = useState(false);
  const [noUser, setNoUser] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [infoError, setInfoError] = useState(false);

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setInfoError(true);
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);

      const userDoc = await getDoc(
        doc(collection(db, "users"), auth.currentUser.uid)
      );

      const userData = userDoc.data();
      console.log(userData);
      localStorage.setItem("fullName", userData.fullName);
      localStorage.setItem("authId", auth.currentUser.uid);
      localStorage.setItem("isAuth", "true");
      localStorage.setItem("lastRef", userData.lastRef);

      navigate("/dashboard");
    } catch (error) {
      setAlert(true);
      if (error.code === "auth/user-not-found") {
        setNoUser(true);
        setWrongPassword(false);
        setVerification(false);
        setNetError(false);
      } else if (error.code === "auth/wrong-password") {
        setNoUser(false);
        setWrongPassword(true);
        setVerification(false);
        setNetError(false);
      } else {
        setNoUser(false);
        setWrongPassword(false);
        setVerification(false);
        setNetError(true);
      }
    }
  };
  return (
    <>
      <div className="signContainer">
        <div className="logInBox">
          <Link to="/">
            <img src="../images/pristinePvLogo.jpg" alt="Logo"></img>
          </Link>
          <div className="loginFrame">
            <h1>Login</h1>
            <form>
              <label>Email ID</label>
              <input
                type="email"
                placeholder="Enter Your Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></input>
              {!email && infoError && <span>This field is mandatory</span>}
              <label>Password</label>
              <div className="passwordInput">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter Your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></input>
                <i
                  className={
                    showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"
                  }
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </div>
              {!password && infoError && <span>This field is mandatory</span>}
            </form>
            <div className="loginButton">
              <button onClick={handleSignIn}>LogIn</button>
            </div>
          </div>
        </div>
      </div>

      {alert && (
        <Alert
          variant={verification ? "success" : "danger"}
          onClose={() => setAlert(false)}
          dismissible
          className="popupMessage"
          style={verification ? {} : { color: "#801a1a" }}
        >
          {wrongPassword && <>Please enter the correct password</>}
          {noUser && <>No User Found Yet</>}
          {verification && (
            <>
              A verification email is sent to your email. Please click the link
              to verify your Email.
            </>
          )}
          {netError && (
            <>Failed to load resource: Due to weak/no internet connection.</>
          )}
        </Alert>
      )}
    </>
  );
}
